function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils.js';
import { GIFT_CARD_EVENT, GIFT_CARD, GIFT_CARD_TYPE, GIFT_CARD_PAGE_TYPE, GIFT_CARD_EVENT_MALL, GIFT_CARD_MALL_SPECIALITY, GIFT_CARD_MALL_FIRST, GIFT_CARD_BALANCE, GIFT_CARD_BALANCE_TYPE, GIFT_CARD_BALANCE_EVENT } from '../../../constants.js';
export function giftcards() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('giftcards.page-load', () => {
    const pageName = GIFT_CARD;
    const pageType = GIFT_CARD_PAGE_TYPE;
    const primaryCategory = GIFT_CARD;
    const subCategory1 = GIFT_CARD;
    const subCategory2 = GIFT_CARD;
    digitalData.page = {
      pageInfo: {
        pageName,
        pageType
      },
      category: {
        primaryCategory,
        subCategory1,
        subCategory2
      }
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('giftcards.check-balance', () => {
    const pageLoadEvent = GIFT_CARD_BALANCE_EVENT;
    const pageName = GIFT_CARD_BALANCE;
    const pageType = GIFT_CARD_BALANCE_TYPE;
    const primaryCategory = GIFT_CARD_BALANCE;
    const subCategory1 = GIFT_CARD_BALANCE;
    const subCategory2 = GIFT_CARD_BALANCE;
    digitalData.page = {
      pageInfo: {
        pageLoadEvent,
        pageName,
        pageType
      },
      category: {
        primaryCategory,
        subCategory1,
        subCategory2
      }
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('giftcards.reload-balance', args => {
    digitalData.page = _objectSpread({}, args === null || args === void 0 ? void 0 : args.output);
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('giftcards.page-load-pip', args => {
    const {
      cardName
    } = args === null || args === void 0 ? void 0 : args.output;
    const pageLoadEvent = GIFT_CARD_EVENT;
    const pageName = GIFT_CARD + '>' + cardName;
    const pageType = GIFT_CARD_TYPE;
    const primaryCategory = GIFT_CARD;
    const subCategory1 = GIFT_CARD;
    const subCategory2 = GIFT_CARD;
    digitalData.page = {
      pageInfo: {
        pageLoadEvent,
        pageName,
        pageType
      },
      category: {
        primaryCategory,
        subCategory1,
        subCategory2
      }
    };
    setAnalytics(digitalData);
  });
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('gift-cards-list.ready', jsonType => {
    let GIFT_CARD_JSON_TYPE;
    let GIFT_CARD_CATEGORY_TYPE;
    if (jsonType.output === 2) {
      GIFT_CARD_JSON_TYPE = GIFT_CARD_MALL_SPECIALITY;
      GIFT_CARD_CATEGORY_TYPE = GIFT_CARD_JSON_TYPE;
    } else {
      GIFT_CARD_JSON_TYPE = GIFT_CARD_MALL_FIRST;
      GIFT_CARD_CATEGORY_TYPE = 'gift card ' + GIFT_CARD_JSON_TYPE;
    }
    const pageLoadEvent = GIFT_CARD_EVENT_MALL;
    const pageName = GIFT_CARD_EVENT_MALL + '>' + GIFT_CARD_JSON_TYPE;
    const pageType = GIFT_CARD + ': ' + GIFT_CARD_JSON_TYPE;
    const primaryCategory = GIFT_CARD_CATEGORY_TYPE;
    const subCategory1 = GIFT_CARD_CATEGORY_TYPE;
    const subCategory2 = GIFT_CARD_CATEGORY_TYPE;
    digitalData.page = {
      pageInfo: {
        pageLoadEvent,
        pageName,
        pageType
      },
      category: {
        primaryCategory,
        subCategory1,
        subCategory2
      }
    };
    setAnalytics(digitalData);
  });
}
// # sourceMappingURL=giftcards.js.map
//# sourceMappingURL=giftcards.js.map